/**
 * 語系常數
 * 集中管理所有應用程式支援的語系
 */

export const LOCALES = {
  // 英文
  EN: "en",
  // 繁體中文
  ZH_TW: "zh-TW",

  // 對應到 Google 登入按鈕的語系
  GOOGLE_LOCALES: {
    EN: "en",
    ZH_TW: "zh-TW",
  },

  // 預設語系
  DEFAULT: "zh-TW",
} as const;

/**
 * 語系顯示名稱
 */
export const LOCALE_NAMES = {
  [LOCALES.EN]: "English",
  [LOCALES.ZH_TW]: "繁體中文",
} as const;

/**
 * 支援的語系列表
 */
export const SUPPORTED_LOCALES = [LOCALES.ZH_TW, LOCALES.EN] as const;

/**
 * 語系類型
 */
export type LocaleType = typeof LOCALES.EN | typeof LOCALES.ZH_TW;
